import React from 'react';
import axios from 'axios';

const { __, getLocaleData } = window.wp.i18n;

class JobApllyButton extends React.Component {

  render() {
    let btn_content = this.props.job_data.apply_job_url;
    let formExists = false;
    if( btn_content && btn_content.indexOf("form_id=") !== -1 ) {
      formExists = true;
    }

    let isBoxEmpty = false;
    let jobSettingOptionData = window.singlejob_desc_setting && Array.isArray(window.singlejob_desc_setting) ? window.singlejob_desc_setting : [];

    if (jobSettingOptionData.length === 0) {
      isBoxEmpty = true;
    }

    return (
      <React.Fragment>
      {
        formExists ?
          (
            <a className="cta-link" data-bs-toggle="modal" data-bs-target="#bs-modal-job-apply" >{ __(' Apply now', 'macs-react-jobs' ) }</a>
          ) :
          (
            <a className={isBoxEmpty ? "cta-link no-margin" : "cta-link"}
             href={this.props.job_data.apply_job_url}>{ __(' Apply now', 'macs-react-jobs' ) }</a>
          )
      }
      </React.Fragment>
    )
  }
}

export default JobApllyButton;
